import { ReactNode } from 'react';
import { Copyright } from '../../Copyright';
import styles from './styles.module.css';

interface LayoutProps {
  children: ReactNode;
}

export function Layout(props: LayoutProps) {
  return (
    <div className={styles.bodyContent}>
      <div className={styles.bodyWrapper}>
        <div className={`container ${styles.bodyHeight}`}>{props.children}</div>
        <div className={styles.bgFooter}>
          <Copyright />
        </div>
      </div>
    </div>
  );
}
